import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LoaformComponent } from './loaform/loaform.component';
import { provideHttpClient, withInterceptorsFromDi, withXsrfConfiguration } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
//import { SuccessformComponent } from './successform/successform.component';


@NgModule({ declarations: [
        AppComponent,
        LoaformComponent
    ],
    bootstrap: [AppComponent, LoaformComponent], imports: [BrowserModule,
        AppRoutingModule,
        FormsModule], providers: [provideHttpClient(withInterceptorsFromDi(), withXsrfConfiguration({}))] })
export class AppModule { }
